import React from "react";
import { ParallaxLayer } from "@react-spring/parallax";
import { SunLayersProps } from "../../../models/sun-layer.model";
import "./SunHome.css";

export const SunLayers: React.FC<SunLayersProps> = ({ offset, transformStyle }) => (
	<>
		<ParallaxLayer
			key={`Sun-bg_red-${offset}`}
			offset={offset}
			speed={0}
			style={{ zIndex: 1 }}
		>
			<div className="bg_red" />
		</ParallaxLayer>

		<ParallaxLayer
			key={`Sun-bg_hill-${offset}`}
			offset={offset}
			speed={0}
			style={{ zIndex: 2 }}
		>
			<div className="bg_hill" />
		</ParallaxLayer>

		<ParallaxLayer
			key={`Sun-sungroup-${offset}`}
			offset={offset}
			speed={-0.2}
			factor={1}
			style={{ zIndex: 3 }}
		>
			<div
				className="sungroup"
				style={transformStyle}
			/>
		</ParallaxLayer>

		<ParallaxLayer
			key={`Sun-hill-${offset}`}
			offset={offset}
			speed={0}
			style={{ zIndex: 5 }}
		>
			<div className="hill" />
		</ParallaxLayer>
	</>
);
